/*
 * <brand-showcase>: widen the panel under the pointer (or with keyboard focus inside it).
 * A short hover-intent delay stops panels thrashing when the pointer sweeps across the row.
 * Desktop only; on phones every panel is open and this does nothing visible.
 */
if (!customElements.get('brand-showcase')) {
  class BrandShowcase extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('.brand-panel'));
      this.timer = null;

      this.panels.forEach((panel, index) => {
        panel.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.activate(index), 90);
        });
        panel.addEventListener('pointerleave', () => clearTimeout(this.timer));
        panel.addEventListener('focusin', () => this.activate(index));
      });
    }

    activate(index) {
      this.panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
    }
  }

  customElements.define('brand-showcase', BrandShowcase);
}
